/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { CloseIcon, ExpressServiceIcon } from "../../../components/Icons";
import { useModal } from "../../../context/ModalContext";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import { usePetStore } from "../../../hooks/redux-hooks/pet-store/pet-store.service";
import { useAppointmentStore } from "../../../hooks/redux-hooks/appointment-store/appointment.store";
import ExpressBookingScheduleContainer from "../../containers/BookingScheduleContainer/ExpressBookingScheduleContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { MODALS } from "../../../config/params";
import { useCancelAndAddAppointment } from "../../../services/appointment/appointment-update-cancel-service";
import { ExpressAppointmentDetailsIndicator } from "../../../components";
import { RESCHEDULE_SOURCE } from "../../../navigation/params";

const RescheduleExpressVisitModal = () => {
  const { closeModal, openModal } = useModal();
  // eslint-disable-next-line no-unused-vars
  const [activeStep, setActiveStep] = useState<number>(0);
  const { petList } = usePetStore();
  const { appointmentForm, setSelectedPets, selectedVisit } = useAppointmentStore();
  const { updateAndCancelAppointment, appointmentone } = useCancelAndAddAppointment();


  const handleCloseModal = ()=>{
    closeModal();
  };

  const handleConfirmBooking = () => {
    updateAndCancelAppointment();
  };


  const handleCtaClick = ()=>{
    switch (activeStep) {
    case 0:
      handleConfirmBooking();
      break;
    default:
      break;
    }
  };
  const handleBackStep = ()=>{
    openModal(MODALS.APPOINTMENT_REVIEW);
  };


  const getStepDetail = (step: number) => {
    switch (step) {
    case 0:
      return (
        <ExpressBookingScheduleContainer isRescheduleModal={true} />
      );

    default:
      return null;
    }
  };

  useEffect(() => {
    if (selectedVisit && selectedVisit.pet && petList) {
      setSelectedPets(petList.filter((pet) => pet.id === selectedVisit.pet.id));
    }
  }, []);

  useEffect(() => {
    if (appointmentone) {
      if (appointmentone.success === false) {
        closeModal();

        return;
      }
      openModal(MODALS.EXPRESS_BOOKING_CONFIRMATION_MODAL, RESCHEDULE_SOURCE.DASHBOARD);
    }
  }, [appointmentone]);


  return (
    <div className="h-full flex flex-col justify-between px-3">
      <div className="w-full flex justify-between">
        <ArrowBackIcon
          onClick={handleBackStep}
          className="text-light-black cursor-pointer"
        />

        <CloseIcon
          onClick={handleCloseModal}
          className="text-light-black cursor-pointer"
        />
      </div>
      <div className="flex flex-col gap-2 items-center">
        <div className="flex items-center justify-center bg-taupe-4 rounded-full p-2 h-fit">
          <ExpressServiceIcon width={40} height={40} />
        </div>
        <div className="flex flex-col items-center gap-1">
          <div className="font-semibold text-2xl">
            Reschedule Express Services
          </div>
          <div className="text-xs text-center">
          Quick, routine technician led care for services like repeat injections,
          nail trims, or vaccine boosters.
          </div>
        </div>
      </div>
      {activeStep !==3 &&
      <div className="my-4 w-full flex flex-col gap-3">
        <ExpressAppointmentDetailsIndicator isReschedule={true} />
      </div>}
      <div className="h-full flex flex-col gap-2 items-center
      justify-between min-h-0 overflow-y-auto !w-full px-2 scrollbar-thin">
        {getStepDetail(activeStep)}
      </div>
      <div className="flex flex-col gap-2 pb-1 pt-1.5 mt-2">
        <StyledBookingFlowButton
          color="primary"
          disabled={appointmentForm?.time ? false : true}
          size="small"
          className="w-full"
          onClick={handleCtaClick}
        >
          {"Continue"}
        </StyledBookingFlowButton>
      </div>
    </div>
  );
};

export default RescheduleExpressVisitModal;
